import { Children, type ReactNode } from 'react';
import { View } from 'react-native';

import { cn } from '@/components/ui/cn';
import { Divider } from '@/components/ui/Divider';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { Surface } from '@/components/ui/Surface';

export interface SettingsGroupProps {
  title?: string;
  children: ReactNode;
  className?: string;
}

/** A titled card of settings rows with hairline dividers. */
export function SettingsGroup({ title, children, className }: SettingsGroupProps) {
  const rows = Children.toArray(children);
  return (
    <View className={cn('gap-2', className)}>
      {title ? <SectionHeader label={title} /> : null}
      <Surface className="overflow-hidden">
        {rows.map((row, i) => (
          <View key={i}>
            {i > 0 ? <Divider className="ml-4" /> : null}
            {row}
          </View>
        ))}
      </Surface>
    </View>
  );
}
